import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import useReactRouter from 'use-react-router'

import makeStyles from '@material-ui/styles/makeStyles/makeStyles'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import EVENTS from '../../constants/events'
import { resetFilters } from '../../constants/filters'
import useCategories from '../../hooks/useCategories'
import trackEvent from '../../lib/trackEvent'
import { SET_SEARCH_KEYWORD_SELECTED } from '../../reducers/searchLawyer'

import { getNextPage } from '../../routeWorkflow'
import { dispatch } from '../../store'
import Button from '../Button'
import AutocompleteCategorie from './AutocompleteCategorie'

const SearchNewContainer = ({
  buttonLabel = <FormattedMessage id={'SearchBar.Search'} defaultMessage={'Rechercher'} />,
  icon = <ArrowForwardIosIcon />,
}) => {
  const classes = useStyles()
  const { categories } = useCategories()
  const history = useHistory()

  const {
    location: { state: { valueAutocomplete = null } = {} },
  } = useReactRouter()

  const [valueSearch, setValueSearch] = useState(valueAutocomplete)
  const [loadingSave, setLoadingSave] = useState(false)

  const handleSearch = () => {
    setLoadingSave(true)

    trackEvent(EVENTS.SEARCH.RUN, valueSearch)

    resetFilters()

    const valueAutocomplete = valueSearch || categories[0]

    dispatch({ type: SET_SEARCH_KEYWORD_SELECTED, payload: valueAutocomplete })

    setLoadingSave(false)

    history.push(`/result-lawyer`)
  }

  return (
    <div className={classes.container}>
      <AutocompleteCategorie setValueSearch={setValueSearch} valueInit={valueSearch} />

      <div>
        <Button
          className={classes.button}
          color={'secondary'}
          variant={'contained'}
          onClick={handleSearch}
          loading={loadingSave}
        >
          {buttonLabel}
          {buttonLabel && '  '}
          {icon}
        </Button>
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: '#ffffff',
    width: '100%',
    border: '1px solid #D5DEE6',
  },
  button: {
    height: 48,
    whiteSpace: 'nowrap',
  },
})

export default SearchNewContainer
